/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { itemRefSchema } from './itemRefSchema';

export const scheduleDriftSummarySchema = z.object({
  largestSlipDays: z.int().nullish(),
  get largestSlipItem() {
    return z.union([itemRefSchema, z.null()]).optional();
  },
  netSlipDays: z.int(),
});
